import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class FeedbackService {

    constructor(
        private http: HttpClient) { }

    /**
     * Get all feedbacks
     */
    index(filter) {
        return this.http.post<any>('api_endpoint' + '/feedback/index', { filter });
    }

    /**
     * Post feedback
     */
    create(feedback) {
        return this.http.post<any>('api_endpoint' + '/feedback/create', { feedback });
    }

    /**
     * Post feedback
     */
    update(feedback, id) {
        return this.http.post<any>('api_endpoint' + '/feedback/update/' + id, { feedback });
    }

}
